import {
    ControllerFieldState,
    FieldValues,
    UseFormStateReturn
} from "react-hook-form";

import { memoizeObject } from "@/utils/memoize";

export const calculateFieldState = <TFieldValues extends FieldValues>(
    fieldState: ControllerFieldState,
    formState: UseFormStateReturn<TFieldValues>
) => {
    return memoizeObject({
        isInvalid:
            (formState.isSubmitted || fieldState.isTouched) &&
            !!fieldState.error,
        isValid:
            (formState.isSubmitted || fieldState.isTouched) && !fieldState.error
    });
};
